<template>
    <div class="vue-active-marker">
        <div class="inner">
            <perfect-scrollbar :options="computedPsOptions">
                <button @click="handleClose" class="close-toggle">{{ backText }}</button>

                <img v-if="marker.image" :alt="marker.title" :src="marker.image" class="detail-image">

                <div class="marker-info">
                    <h3><a :href="marker.url">{{ marker.title }}</a></h3>

                    <div class="info">
                        <div class="address-wrapper">
                            <span>
                                {{ marker.streetNumber }}<br>
                                {{ marker.postalCodePlace }}<br>
                            </span>

                            <div class="klantenvertellen mt-1" v-if="hasKlantenvertellen">
                                {{ marker.klantenvertellen.averageScore }}
                            </div>
                        </div>

                        <a :href="marker.url" class="cta-button mt-4">{{ goToCompanyPageText }}</a>

                        <div class="office-hours-mini mt-4 mb-0">
                            <template v-if="isOpen && currentSlot">
                                <span class="font-weight-bold">{{ openText }}</span>
                                {{ currentSlot }}
                            </template>

                            <template v-else>
                                {{ closedText }}
                            </template>
                        </div>

                        <template v-if="this.parsedPhonenumber">
                            Tel: <a :href="`tel:${parsedPhonenumber}`">{{ marker.tel }}</a><br>
                        </template>

                        <a :href="'mailto:'+marker.email">{{ sendAnEmailText }}</a>
                    </div>
                </div>
            </perfect-scrollbar>
        </div>
    </div>
</template>

<script>
import parsePhoneNumber from './../../../../../themes/custom/ef2_custom/node_modules/libphonenumber-js';
import OpeningHours from "../mixins/OpeningHours";
import translationsMixin from '../../../../../themes/custom/ef2_custom/js/vue/mixins/translations.js'

export default {
    name: "ActiveMarker",

    mixins: [OpeningHours, translationsMixin],

    props: {
        marker: {
            type: Object,
            required: true
        },
        eventBus: {},
        modalBus: {},
        isMobile: {},
    },

    mounted() {
        Drupal.ajax.bindAjaxLinks(document.body);
        this.$emit('alive');
    },

    computed: {
        hasKlantenvertellen() {
            return !_.isEmpty(this.marker.klantenvertellen) && this.marker.klantenvertellen.averageScore !== 0;
        },

        appointmentUrl() {
            const lang = document.documentElement.lang.toLowerCase();
            const prefix = lang === 'nl' ? '' : `/${lang}`;
            return `${prefix}/form/afspraak-maken?source_entity_type=garage_entity&source_entity_id=${this.marker.id}`
        },

        uniqueId() {
            return _.uniqueId('appointment-button-');
        },

        parsedPhonenumber() {
            if (_.isEmpty(this.marker.tel)) {
                return;
            }

            return parsePhoneNumber(this.marker.tel, 'BE').number;
        },

        hasPlannerUrl() {
            return ! lodash.isNil(this.marker.plannerUrl);
        },

        computedPsOptions() {
            if (this.isMobile) {
                return {}
            }

            return {wheelPropagation: false}
        }
    },

    methods: {
        handleClose() {
            this.eventBus.$emit('remove-active-marker');
        },
    }
}
</script>